import cn from "classnames";
import { type FC, type ReactNode } from "react";

interface SelectionButtonProps {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  body?: ReactNode;
  titleExtra?: ReactNode;
  subTitleExtra?: ReactNode;
  description: string;
  selected?: boolean;
  className?: string;
  onClick?: () => void;
}

export const SelectionButton: FC<SelectionButtonProps> = ({
  icon,
  title,
  subtitle,
  body,
  titleExtra,
  subTitleExtra,
  description,
  selected,
  className,
  onClick,
}) => {
  const baseStyle = "w-full flex gap-4 rounded-2xl text-lg p-4 text-start";
  const selectedStyle = "border-2 border-primary bg-primary bg-opacity-10";
  const unselectedStyle = "bg-secondary-bg";

  const buttonStyle = cn(
    {
      [baseStyle]: true,
      [selectedStyle]: selected,
      [unselectedStyle]: !selected,
    },
    className
  );

  return (
    <div
      role="button"
      tabIndex={0}
      className={buttonStyle}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (onClick) onClick();
        }
      }}
    >
      {icon && (
        <div className={selected ? "text-primary" : "text-secondary-text"}>
          {icon}
        </div>
      )}
      <div className="w-full flex flex-col items-start">
        <div className="w-full flex justify-between font-semibold">
          {title}
          {titleExtra && (
            <div className="text-primary text-xl">{titleExtra}</div>
          )}
        </div>
        {subtitle ? (
          <div className="w-full flex justify-between text-sm font-semibold">
            {subtitle}
            <div>{subTitleExtra}</div>
          </div>
        ) : undefined}
        {body}
        <div className="text-base mt-3 text-secondary-text">{description}</div>
      </div>
    </div>
  );
};
